import moment from 'moment';

export default function (date) {
  if (date) {
    return moment(date).format('DD/MM/YYYY [às] HH:mm');
  }

  return null;
}
